<template>
  <circle cx="18.5" cy="18.5" r="18.5" fill="#FFED00" />
  <path
    d="M25 15.5V13C25 11.3431 23.6569 10 22 10H15C13.3431 10 12 11.3431 12 13V25C12 26.6569 13.3431 28 15 28H22C23.6569 28 25 26.6569 25 25V22.5"
    stroke="#233F1F"
    stroke-width="1.5"
    stroke-linecap="round" />
  <path
    d="M19 19H30M30 19L28.35 16M30 19L28.35 22"
    stroke="#233F1F"
    stroke-width="1.5"
    stroke-linecap="round" />
</template>
